import type { Occurrence } from '../lib/types';
import { frequencyLabel, relativeDue } from '../lib/format';

interface Props {
  items: Occurrence[];
  today: string;
  onToggle?: (occurrence: Occurrence, done: boolean) => void;
  readOnly?: boolean;
}

export default function ChoreList({ items, today, onToggle, readOnly }: Props): JSX.Element {
  return (
    <div>
      {items.map((item) => {
        const done = item.state === 'done';
        const late = item.state === 'overdue';
        return (
          <button
            key={`${item.choreId}:${item.periodKey}`}
            type="button"
            className={`chore${done ? ' done' : ''}${late ? ' overdue' : ''}`}
            disabled={readOnly}
            onClick={() => onToggle?.(item, !done)}
          >
            <span className="chore-icon">{item.icon}</span>
            <span className="grow">
              <span className="chore-title">{item.title}</span>
              <span className="row wrap tiny muted" style={{ gap: 6, marginTop: 2 }}>
                <span>{frequencyLabel(item.frequency)}</span>
                {item.frequency !== 'daily' && <span>· due {relativeDue(item.dueDate, today)}</span>}
                {late && (
                  <span className="badge bad">
                    {item.alsoMissed ? `Missed ${item.alsoMissed + 1}×` : 'Overdue'}
                  </span>
                )}
                {item.points > 1 && <span className="badge">{item.points} pts</span>}
                {!item.countsForPay && <span className="badge">Bonus</span>}
              </span>
            </span>
            <span className="tickbox">✓</span>
          </button>
        );
      })}
    </div>
  );
}
